export default class Autocomplete {
  constructor(el, feed, resultpage) {
    this.el = el;
    this.feed = feed;
    this.resultpage = resultpage;
    this.inputHandler();
  }

  inputHandler() {
    this.el.addEventListener('input', (e) => {
      if (e.target.value.length >= 3) {
        fetch(`${this.feed}${e.target.value}`)
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            this.displayResults(data);
          });
      } else {
        this.removeAutocomplete();
        this.removeNavHandler();
      }
    });
    return;
  }

  addNavHandler() {
    window.addEventListener('keypress', this.navHandler);
    return;
  }

  removeNavHandler() {
    window.removeEventListener('keypress', this.navHandler);
    return;
  }

  navHandler(event) {
    return;
  }

  displayResults(data) {
    const list = data.map((item) => {
      return `<li><a href="${this.resultpage}${item}">${item}</a></li>`;
    });
    if (!document.querySelector('.autocomplete')) {
      this.el.insertAdjacentHTML(
        'afterend',
        `<div class="autocomplete"><ul></ul></div>`
      );
    }
    document.querySelector('.autocomplete ul').innerHTML = list.join('');
    this.addNavHandler();
    return;
  }

  removeAutocomplete() {
    if (document.querySelector('.autocomplete')) {
      const el = document.querySelector('.autocomplete');
      el.parentNode.removeChild(el);
    }
    return;
  }
}
